import React, { useEffect } from "react";
import Homebloodcon from "./homebloodcon";
import Infiry from "../../About/Infiry";
import Callin from "../../About/Callin";
import Servicebanner from "../../Services/Servicebanner";
import NumberInfo from "../../Home/NumberInfo";
import Doctorbox from "../../Home/Docterbox";
import Divser from "../../About/Divser";
import Divider from "../../Divider";
import ServiceReview from "../../Services/ServiceReview";
import { movetop } from "../../../fun";
import { Helmet } from "react-helmet-async";

function Homeblood() {
  useEffect(() => {
    movetop();
  }, []);
  type elem = {
    oneBody?: JSX.Element;
    twoBody?: JSX.Element;
    threeBody?: JSX.Element;
  };
  const elemnt: elem = {
    oneBody: <Homebloodcon />,
    twoBody: <Infiry />,
    threeBody: <Callin />,
  };
  return (
    <>
      <Helmet>
        <title>Home Blood Collection Service in Whitefield</title>
        <meta
          name="description"
          content="We are the best Home Blood Collection Service in Whitefield and Vijayanagar. Feel free to contact us today or call us now."
        />
        <meta
          name="keywords"
          content="Best Home Blood Collection Service in Whitefield, Best Home Blood Collection Service in Vijayanagar, healthcare services in Whitefield, healthcare services in Vijayanagar, Multispeciality Clinic in Vijayanagar"
        />

        {/* JSON-LD Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "MedicalBusiness",
            "@id":
              "https://www.elvhealthcare.com/besthomebloodservicesinwhitefield#organization",
            name: "ELV Health Care Polyclinics",
            url: "https://www.elvhealthcare.com/besthomebloodservicesinwhitefield",
            description:
              "ELV Health Care Polyclinics in Whitefield provides reliable home blood sample collection services for routine and advanced laboratory tests with qualified phlebotomists, hygienic procedures, and fast report delivery for convenient health monitoring.",
            logo: "https://www.elvhealthcare.com/favicon.ico",
            telephone: ["+91-9535264855", "+91-9535264854"],
            email: "elvhealthcare@gmail.com",
            address: {
              "@type": "PostalAddress",
              streetAddress: "MR ASTER, Ground Floor, Vijayanagar, Whitefield",
              addressLocality: "Bengaluru",
              addressRegion: "Karnataka",
              postalCode: "560066",
              addressCountry: "IN",
            },
            geo: {
              "@type": "GeoCoordinates",
              latitude: 12.9764418,
              longitude: 77.7583566,
            },
            hasMap: "https://maps.app.goo.gl/C1xXW4kQyTxR8Sug9",
            knowsAbout: [
              "Home blood sample collection",
              "Routine blood test collection at home",
              "CBC testing and metabolic profile collection",
              "Thyroid, HbA1c and glucose testing",
              "Senior citizen and bedridden patient support",
              "Safe and hygienic collection process",
              "Digital lab report delivery",
              "Pre-test instructions and counselling",
            ],
            keywords: [
              "best home blood services in Immadihalli",
              "best home blood services in Whitefield",
              "best home blood services in Bangalore",
              "best home blood services in Kundalahalli",
              "best home blood services in Pattandur Agrahara",
            ],
          })}
        </script>
      </Helmet>

      <h2 style={{ display: "none" }}>
        Home Blood Collection Service in Whitefield promoting proactive health
        management and contributing to their overall well-being. Contact us as
        we give the best Home Blood Collection Service in Whitefield.
      </h2>
      <Servicebanner
        name="Home blood sample collection"
        banner={"../photo/dd10.jpg"}
      />
      <NumberInfo test="test-black" />
      <Doctorbox />
      <Divser elemnt={elemnt} />
      {/* <div className="pt-6">
                        <Divider />
                      </div>
                      <Doctorbox /> */}
      <div className="pt-10 pb-4">
        <Divider />
      </div>
      <ServiceReview />
    </>
  );
}

export default Homeblood;
